import { createStyles, makeStyles, Theme } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { baseTheme } from '../theme';
import SubmitButton from '../components/form-elements/submit-button';
import IndividualCreateForm from '../components/account-forms/create-account-forms/individual-create-form';
import RelihtFeaturesList from '../components/reliht-features/reliht-features-list';
import InstructionList from '../components/home-components/instruction-list';
import { homePageInstructionsMobileData } from '../data/home-page-instructions-mobile';
import { homePageInstructionsWeb1 } from '../data/home-page-instructions-web-1';
import { homePageInstructionsWeb2 } from '../data/home-page-instructions-web-2';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
    },
    imageWidth: {
      maxWidth: '380px',
    },
    sectionOne: {
      paddingTop: theme.spacing(5),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      paddingBottom: 0,
      backgroundColor: theme.palette.background.paper,
      textAlign: 'center',
    },
    sectionTwo: {
      paddingTop: theme.spacing(5),
      paddingLeft: theme.spacing(5),
      paddingRight: theme.spacing(5),
      paddingBottom: theme.spacing(10),
      backgroundColor: theme.palette.text.disabled,
      textAlign: 'center',
    },
    sectionTwoLeftColumn: {
      paddingLeft: theme.spacing(5),
      paddingRight: theme.spacing(5),
    },
    startedImgContainer: {
      textAlign: 'center',
      width: '10%',
      marginTop: '10%',
    },
    logoRow: {
      marginBottom: '2em',
    },
    actionArea: {
      flexGrow: 1,
    },
    actionContainer: {
      minWidth: '200px',
      maxWidth: '1050px',
      margin: '0 auto',
    },
    sectionOneBottomRow: {
      margin: '0 auto',
      paddingLeft: theme.spacing(5),
    },
    sectionOneBottomRowText: {
      alignContent: 'flex-end',
      paddingBottom: theme.spacing(4),
      paddingRight: theme.spacing(4),
    },
    submitContainer: {
      minWidth: '200px',
      maxWidth: '1200px',
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(4),
      marginLeft: 'auto',
      marginRight: 'auto',
      display: 'flex',
      alignItems: 'center',
    },
    submitButtonWrapper: {
      maxWidth: '450px',
      alignSelf: 'center',
    },
    largeButton: {
      fontSize: '2em',
    },
    callToAction: {
      padding: '5px',
    },
    subtitle: {
      paddingTop: theme.spacing(1),
    },
    instructions: {
      flexGrow: 1,
      paddingTop: theme.spacing(6),
    },
    sectionThree: {
      paddingTop: theme.spacing(10),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      paddingBottom: theme.spacing(10),
      textAlign: 'center',
    },
    sectionThreeColumn: {
      height: '100%',
      flexGrow: 1,
      display: 'flex',
      minHeight: '895px',
      justifyContent: 'space-between',
    },
    sectionThreeColumnText: {
      paddingLeft: theme.spacing(5),
      paddingRight: theme.spacing(10),
    },
    sectionThreeColumnBottom: {
      paddingLeft: theme.spacing(5),
      paddingRight: theme.spacing(5),
    },
    sectionFour: {
      paddingTop: theme.spacing(10),
      paddingLeft: theme.spacing(7),
      paddingRight: theme.spacing(7),
      paddingBottom: theme.spacing(10),
    },
    normalWeightHeaderText: {
      fontSize: '3em',
    },
    sectionFourHeaderSubtitleText: {
      fontSize: '1.4em',
      lineHeight: '2.5em',
      fontWeight: 'bolder',
    },
    sectionFourSubHeaderText: {
      fontSize: '1.7em',
      fontWeight: 'bolder',
    },
    pdfLogo: {
      height: '1.7em',
      marginRight: theme.spacing(1),
    },
    xxlFont: {
      fontSize: '4em',
      marginBottom: theme.spacing(1),
    },
    planItem: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.background.default,
      marginLeft: theme.spacing(3),
      marginRight: theme.spacing(3),
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
      paddingBottom: theme.spacing(10),
    },
    planContent: {
      paddingTop: theme.spacing(10),
      paddingBottom: theme.spacing(10),
      minHeight: '600px',
    },
    planHeading: {
      fontSize: '2.5em',
    },
    standardText: {
      lineHeight: '2em',
      fontSize: '1.2em',
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
    emphasisText: {
      fontSize: '1.8em',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
    },
    boldedHeading: {
      fontSize: '3em',
      fontWeight: 450,
    },
    explanatoryText: {
      lineHeight: '1.5em',
      fontSize: '1.4em',
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
    unBoldExplanatoryText: {
      lineHeight: '1.5em',
      fontSize: '1.5em',
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      fontWeight: 'normal',
    },
    explanatoryBoldText: {
      lineHeight: '1.5em',
      fontWeight: 'bold',
      fontSize: '1.5em',
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
    tagBoldText: {
      lineHeight: '1.5em',
      fontWeight: 'bold',
      fontSize: '1.5em',
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
    boldedBottomHeadlineText: {
      fontSize: '3em',
      fontWeight: 'bold',
    },
    actionButton: {
      fontSize: '1.5em',
    },
    heading: {
      fontWeight: 'normal',
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
    monetizationImage: {
      height: '12em',
    },
    welcomeToRelihtContainer: {
      paddingBottom: 0,
      alignContent: 'flex-end',
      marginBottom: -1,
      lineHeight: 0,
    },
    welcomeToRelihtImage: {
      height: 240,
    },
    relihtAppImage: {
      width: '90%',
      margin: theme.spacing(5),
      paddingRight: theme.spacing(5),
    },
    featuresText: {
      paddingTop: theme.spacing(1),
      fontSize: '1em',
      fontWeight: 'bold',
    },
    welcomeBoldedText: {
      fontWeight: 'bold',
    },
    welcomeContainer: {
      alignContent: 'flex-end',
    },
    welcomeDownArrow: {
      marginTop: theme.spacing(2),
    },
  }),
);

export default function HomePage(props: any) {
  const classes = useStyles(baseTheme);
  const history = useHistory();
  useEffect(() => {
    if (props.signUp) {
      scrollToForm();
    }
  }, [props.signUp]);

  const handleRoute = (route: string) => () => {
    history.push(route);
  };
  const scrollToForm = () => {
    const signUoForm = document.getElementById('sign-up-form');
    if (signUoForm) {
      signUoForm.scrollIntoView();
    }
  };

  return (
    <Grid item container direction="column" className={classes.root}>
      <Grid item className={classes.sectionOne}>
        <Grid container direction="row" className={classes.logoRow}>
          <Grid xs={3} item>
            <img
              src="/images/monetize_2026.png"
              alt="Monetize - Coming 2026"
              className={classes.monetizationImage}
            />
          </Grid>
          <Grid xs={6} item className={classes.actionContainer}>
            <img
              className={classes.imageWidth}
              src="/images/Reliht_logo.svg"
              alt="Reliht - Equipping Leaders for the Kingdom of God"/>
            <Typography color="primary" variant="h5">
              Equipping Leaders for the Kingdom of God
            </Typography>
          </Grid>
          <Grid xs={3} item></Grid>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h3" color="primary">
            One place to create, organize, store, and share God notes.
          </Typography>
        </Grid>
        <Grid item justify="center" className={classes.submitContainer}>
          <div className={classes.submitButtonWrapper}>
            <SubmitButton
              className={classes.largeButton}
              text="Sign up is FREE. Get started today!"
              onClick={scrollToForm}
            />
          </div>
        </Grid>
        <Grid item className={classes.sectionOneBottomRow}>
          <Grid container direction="row">
            <Grid item xs={8} className={classes.sectionOneBottomRowText}>
              <Typography
                color="primary"
                variant="h3"
                align="left"
                className={classes.normalWeightHeaderText}>
                We're different than social. No chat to distract.
              </Typography>
              <Typography
                color="primary" variant="h6" className={classes.explanatoryBoldText} align="left">
                Step away from social chat and into our online "quiet messaging space".
                Spend time in reflection with God and take notes &mdash; level up and let God
                be your influencer.
              </Typography>
              <Typography
                color="textSecondary" variant="h6" className={classes.unBoldExplanatoryText} align="left">
                We've designed Reliht&#8482; as a place to record God notes and share them
                &mdash; without the chat. Why? Well, to be honest, we probably don't need
                another social platform. And spending time with the Father, Son, and
                Holy Spirit doesn't require social feedback. Instead, it's God + you.
              </Typography>
            </Grid>
            <Grid item xs={2} direction="column" className={classes.welcomeContainer}>
              <Typography variant="h4" color="primary" className={classes.welcomeBoldedText}>
                Welcome!
              </Typography>
              <Typography variant="h4" color="primary" className={classes.welcomeBoldedText}>
                Learn more
              </Typography>
              <Typography variant="h4" color="primary" className={classes.welcomeBoldedText}>
                about Reliht&#8482;
              </Typography>
              <Typography variant="h4" color="primary" className={classes.welcomeBoldedText}>
                and sign up
              </Typography>
              <Typography variant="h4" color="primary" className={classes.welcomeBoldedText}>
                FREE below!
              </Typography>
              <img
                src="/images/arrow_down.png"
                alt="Arrow Down"
                className={classes.welcomeDownArrow}
              />
            </Grid>
            <Grid item xs={2} direction="column" className={classes.welcomeToRelihtContainer}>
              <img
                src="/images/Welcome_to_Reliht.png"
                alt="Welcome to Reliht"
                className={classes.welcomeToRelihtImage}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid xs={12} direction="row" item container className={classes.sectionTwo}>
        <Grid item xs={8} className={classes.sectionTwoLeftColumn}>
          <Typography
            color="primary"
            variant="h3"
            align="left"
            className={classes.normalWeightHeaderText}
          >
            Reliht&#8482; Features on web and mobile app
          </Typography>
          <RelihtFeaturesList/>
        </Grid>
        <Grid item xs={4}>
          <img
            src="/images/Reliht_app.png"
            alt="Reliht app on phone"
            className={classes.relihtAppImage}
          />
        </Grid>
      </Grid>
      <Grid item className={classes.sectionThree}>
        <Grid container justify="space-between" alignItems="stretch">
          <Grid
            item
            xs={8}
            alignContent="stretch"
            justify="space-between"
            direction="column" className={classes.sectionThreeColumn}>
            <Grid item className={classes.sectionThreeColumnText}>
              <Typography
                variant="h3"
                color="primary"
                className={classes.normalWeightHeaderText}
                align="left"
              >
                Getting Started with Reliht&#8482;
              </Typography>
              <Typography align="left">
                <Typography
                  color="primary"
                  variant="h5"
                  className={classes.explanatoryBoldText}
                  align="left"
                >
                  Follow your favorites. Journal privately. Create content + share to followers
                  on the Reliht&#8482; app. It's like swimming &mdash; start in the shallow water,
                  wade in, then go deep...
                </Typography>
              </Typography>
              <br/>
              <Typography align="left">
                <Typography
                  display="inline"
                  color="primary"
                  variant="h5"
                  align="left"
                  className={classes.explanatoryBoldText}>
                  Keeping it simple?
                </Typography>
                <Typography
                  display="inline"
                  color="textSecondary"
                  variant="h5"
                  align="left"
                  className={classes.explanatoryText}>
                  &nbsp;Get your feet wet by following your favorites on the mobile app. Copy their
                  shared notes to your personal library and add your own affirmations.
                </Typography>
              </Typography>
              <br/>
              <Typography align="left">
                <Typography
                  display="inline"
                  color="primary"
                  variant="h5"
                  className={classes.explanatoryBoldText}>
                  Like to journal?
                </Typography>
                <Typography
                  display="inline"
                  color="textSecondary"
                  variant="h5"
                  className={classes.explanatoryText}>
                  &nbsp;Wade in further and journal privately. You can even highlight and view
                  your private journal notes on the app. Only you can see private notes when they
                  aren't assigned to groups.
                </Typography>
              </Typography>
              <br/>
              <Typography align="left">
                <Typography
                  display="inline"
                  color="primary"
                  variant="h5"
                  className={classes.explanatoryBoldText}>
                  Ready to create content and share with others?
                </Typography>
                <Typography
                  display="inline"
                  color="textSecondary"
                  variant="h5"
                  className={classes.explanatoryText}>
                  &nbsp;Do a deep dive! Reliht&#8482; is a great space for authors,
                  content creators, coaches, mentors, and leaders to prepare and share
                  a message. We help you organize, sort, and store all types of notes
                  with tags. Assign a closed or public group to your notes.
                  GO LIVE AND SHARE WITH FOLLOWERS. It's that easy!
                </Typography>
              </Typography>
              <Typography align="left">
                <Typography
                  color="textSecondary"
                  variant="h5"
                  align="left"
                  className={classes.explanatoryText}>
                  The Reliht&#8482; app gives you a feed where you can showcase thumbnail pics along
                  with your notes. If you're a leader, have people find and follow you on the Reliht
                  app.
                </Typography>
              </Typography>
              <br/>
                <Typography
                  color="primary"
                  variant="h5"
                  className={classes.explanatoryBoldText}
                  align="left">
                  Reliht&#8482; is a tool to help you AND others grow with God but also,
                  as you share notes, it will equip you to lead in God's Kingdom.
                </Typography>
            </Grid>
            <Grid
              item
              container
              justify="space-between"
              direction="row"
              alignItems="center"
              className={classes.sectionThreeColumnBottom}
            >
              <Typography
                color="primary"
                variant="h4"
                className={classes.boldedBottomHeadlineText}
                align="left">
                You get BOTH web and mobile app when you sign up!
              </Typography>
            </Grid>
          </Grid>
          <Grid item md={4} lg={4}>
            <div id="sign-up-form">
              <IndividualCreateForm submitText="Sign up FREE" themeStyle="light"/>
            </div>
          </Grid>
        </Grid>
      </Grid>
      <Grid item className={classes.sectionFour} direction="row" xs={12}>
        <Typography color="primary" className={classes.normalWeightHeaderText} variant="h3">
          How To Use Reliht&#8482;
        </Typography>
        <Typography color="primary" className={classes.sectionFourHeaderSubtitleText} variant="h3">
          Click on links below to learn how to use Reliht web and mobile app.
        </Typography>
        <Grid container direction="row" justify="space-between">
          <Grid item container xs={4}>
            <InstructionList name={'WEB APP'} links={homePageInstructionsWeb1}/>
          </Grid>
          <Grid item container xs={4}>
            <InstructionList name={''} links={homePageInstructionsWeb2}/>
          </Grid>
          <Grid item container xs={4}>
            <InstructionList name={'MOBILE APP'} links={homePageInstructionsMobileData}/>
          </Grid>
        </Grid>
        <Typography></Typography>
      </Grid>
    </Grid>
  );
}
